import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { DES_EVO_TENANT_TOKEN, DES_EVO_USER_TOKEN, DES_I_AM_TOKEN, DES_RECAPTCHA_TOKEN } from "@jti/fe-common";

import { sanitizeBaseUrl } from "./sanitizeBaseUrl";

export const X_BRAND_HEADER = "X-BRAND";
export const X_DES_ORG_BRAND_HEADER = "X-DES-ORG-BRAND";

const getEnvBrand = (): string | undefined => {
  try {
    return process.env.NEXT_PUBLIC_BRAND || undefined;
  } catch {
    return undefined;
  }
};

export type EvoClientParams = {
  baseUrl: string;
  recaptchaId: string;
  tenantToken: string;
  throwOnError?: boolean;
  ciamToken: string;
  brand?: string;
};

export type EvoClientDeps = {
  createClient: (config: any) => any;
  createConfig: (options: any) => any;
};

export const buildEvoClientConfig = (
  { createConfig }: Pick<EvoClientDeps, "createConfig">,
  { baseUrl, recaptchaId, tenantToken, throwOnError = false, ciamToken, brand = getEnvBrand() }: EvoClientParams
) =>
  createConfig({
    baseUrl: sanitizeBaseUrl(baseUrl),
    headers: brand ? { [X_BRAND_HEADER]: brand, [X_DES_ORG_BRAND_HEADER]: brand } : undefined,
    async auth(auth: { name: string }) {
      switch (auth.name) {
        case DES_RECAPTCHA_TOKEN:
          return getGoogleReCaptchaToken(recaptchaId);
        case DES_EVO_TENANT_TOKEN:
          return tenantToken;
        case DES_I_AM_TOKEN:
        case DES_EVO_USER_TOKEN:
          return ciamToken;
        default:
          return;
      }
    },
    throwOnError,
  });

export const makeCreateEvoClient = (deps: EvoClientDeps) => (params: EvoClientParams) =>
  deps.createClient(buildEvoClientConfig(deps, params));
